import axios from 'axios';

export default function LanguagesService(gettextCatalog, appSettings) {
  'ngInject';

  this.getSupportedLanguages = () => appSettings.SupportedLanguages || [];

  this.setCurrentLanguage = async (lang = 'en') => {
    gettextCatalog.debug = appSettings.environment === appSettings.environments.local;

    gettextCatalog.setCurrentLanguage(lang);
    // gettextCatalog.baseLanguage is 'en'
    if (lang !== 'en') {
      return gettextCatalog.loadRemote(`${process.env.TRANSLATION_CDN_URL}/locale/${lang}.json`);
    }
  };
}
